import { isModuleAvailable } from '../../constants/moduleAvailability';

export const filterAvailableMenuGroups = (menuGroups) => (
  menuGroups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => isModuleAvailable(item.id))
    }))
    .filter((group) => group.items.length > 0)
);
